import React from 'react';
import { Outlet } from 'react-router-dom';

const Index = () => {
    return (
        <div className='flex min-h-screen bg-white'>
            <div className='relative flex flex-1 flex-col justify-center px-6 py-12 lg:w-2/5 lg:flex-none' style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/images/doku.png'})`, backgroundRepeat: 'repeat-x' }}>
                <Outlet />
            </div>
            <div className='bg-slate-200 relative hidden w-0 flex-1 items-center justify-center lg:flex lg:w-3/5'>
                <img className='w-full h-screen object-cover' src='https://www.odu.edu.tr/dist/images/LoginPageImages/odukampus.jpg' alt='ODÜ Kampüs' />
            </div>
        </div>
    );
}

export default Index;
